<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="row">
              <div class="col-md-4">
                <input class="form-control pull-right" type="search" placeholder="Search Workflow Groups" id="example-search-input" v-model="searchQuery">
              </div>
              <div class="col-md-2" v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99">
                <router-link class="btn btn-success" to="/admin/workflowgroup/create">Add</router-link>
              </div>
            </div>
            <br/>
            <data-table :data="workflowGroups" :workflows="workflows" :columns="columns" :filter-key="searchQuery"></data-table>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
    </div>
  </div>
</template>

<script>
import DataTable from "./WorkflowGroupsTable";
import database from "../../webmaster/Database/database";
import store from "../../webmaster/Store/vuex";

export default {
  name: "workflowgroups",
  components: {
    "data-table": DataTable
  },
  data() {
    return {
      searchQuery: "",
      columns: ["name", "workflows", "more"],
      workflowGroups: [],
      workflows: [],
      org: store.state.usermain,
    };
  },
  created: function() {
    this.fetchAll()
  },
  methods: {
    fetchAll:function(){
      this.fetchWorkflows()
      this.fetchWorkflowGroups()
      //this.fetchDefaultWorkflowGroup()
    },
    fetchWorkflows:function(){
      //Get all workflows
      var workflowsRef = '/orgs/' + this.$store.state.usermain.curOrg.id + '/meta_workflows'

      this.$bindAsArray('workflows', database.getRef(workflowsRef));
    },
    fetchWorkflowGroups:function(){
      //Get all workflow groups
      var ref = "/orgs/" + this.$store.state.usermain.curOrg.id + "/workflow_groups";

      this.$bindAsArray("workflowGroups", database.getRef(ref));
    },
    fetchDefaultWorkflowGroup:function(){
      //Get default workflow group
      var ref = "/orgs/" + this.$store.state.usermain.curOrg.id + "/defaultworkflowgroup";

      this.$bindAsObject("defaultworkflowgroup", database.getRef(ref));
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// WorkflowGroups.vue?ce8eab8e